import { createSlice } from "@reduxjs/toolkit";

const initialState = {};    


const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: { 
    }
});


export default globalSlice.reducer;